import { Outlet } from "react-router-dom";
import { PublicNav } from "@/components/PublicNav";
import { PublicFooter } from "@/components/PublicFooter";
import { DeferredAssistantWidget } from "@/components/assistant/DeferredAssistantWidget";

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background overflow-x-hidden">
      <PublicNav />
      <main className="flex-1 pt-14">
        <Outlet />
      </main>
      <PublicFooter />
      <DeferredAssistantWidget context="public" />
    </div>
  );
}
